export default "__VITE_ASSET__CYSi9yiQ__"